// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4317":"80d40126","4648":"5ed7add4","6271":"94c9f2c2","9384":"5ed7add4"}[chunkId] + ".chunk.css";
};